import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withReduxProvider from "web/react/redux-provider";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import MultiplyOnHoverButton from "web/react/components/buttons/multiply-on-hover-button/multiply-on-hover-button";
import { gettext } from "web/script/modules/django-i18n";
import LeadLink from "web/react/components/lead-link/lead-link";
import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";
import styles from "./buy-on-store-button.css";

export function BuyOnStoreButton({
    leadUrl,
    leadLabel,
    openCustomerCaptureOverlay,
    productId,
    reason,
    features,
    beforeOnClick,
}) {
    function onClickBuyNow() {
        if (!userProfiler.isLoggedIn() && environment.get("boomLeadSignupPrompt")) {
            openCustomerCaptureOverlay({
                productId: productId,
                captureType: "signup_lead_save",
            });
        }
    }

    let button = (
        <MultiplyOnHoverButton
            className={styles.buttonMultiply}
            fullHeight
            fullWidth
            element={"span"}
        >
            {leadLabel}
        </MultiplyOnHoverButton>
    );
    let newColourScheme =
        typeof features !== "undefined" && features != null
            ? features.pmt_580_new_colour_scheme
            : null;

    if (newColourScheme) {
        button = (
            <MultiplyOnHoverButton
                className={styles.buttonMultiply}
                styleType="secondary"
                fullHeight
                fullWidth
                element="span"
            >
                {leadLabel}
            </MultiplyOnHoverButton>
        );
    }

    return (
        <LeadLink
            beforeOnClick={beforeOnClick}
            afterOnClick={onClickBuyNow}
            href={leadUrl}
            openInNewTab={true}
            productId={productId}
            reason={reason}
        >
            {button}
        </LeadLink>
    );
}

BuyOnStoreButton.propTypes = {
    leadLabel: PropTypes.string,
    leadUrl: PropTypes.string.isRequired,
    openCustomerCaptureOverlay: PropTypes.func,
    productId: PropTypes.string.isRequired,
    reason: PropTypes.string,
    features: PropTypes.object,
    beforeOnClick: PropTypes.func,
};

BuyOnStoreButton.defaultProps = {
    leadLabel: gettext("product.buy_area.shop_now"),
    reason: "buy-on-store-button",
};

export default withReduxProvider(connect(null, { openCustomerCaptureOverlay })(BuyOnStoreButton));
